export const FETCH_PROJECTS_BEGIN = "FETCH_PROJECTS_BEGIN";
export const FETCH_PROJECTS_SUCCESS = "FETCH_PROJECTS_SUCCESS";
export const FETCH_PROJECTS_FAILURE = "FETCH_PROJECTS_FAILURE";
export const OPEN_CREATE_PROJECT_MODAL = "OPEN_CREATE_PROJECT_MODAL";
export const CLOSE_CREATE_PROJECT_MODAL = "CLOSE_CREATE_PROJECT_MODAL";
